module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toctitle"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Ch01"
    }
  }, [_vm._v("Materials & tools")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic crochet techniques")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The projects")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Abbrevation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SNOWMEN")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SANTA CLAUS AND MRS CLAUS")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELVES")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REINDEER")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS STOCKING")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS GIFTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS CRACKER")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS TREE")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROBIN")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOLLY BERRIES")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS STAR")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANGEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTMAS PUDDING")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PENGUIN")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRUSSELS SPROUTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MINCE PIES")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CARROTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIGS IN BLANKETS")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GINGERBREAD MAN")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/4-20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Ch03#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POLAR BEAR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b863104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 78
// module chunks = 0